import { Button, Icon, Popup } from "semantic-ui-react";

import "components/ExportDataButton/ExportDataButton.scss";

type ExportDataButtonProps = {
  hasWarning?: boolean;
  disabled?: boolean;
  contentMessage?: string;
  handleOnClick: () => void;
};

export const ExportDataButton = ({ handleOnClick, hasWarning = false, disabled = false, contentMessage = "" }: ExportDataButtonProps) => {
  if (disabled)
    return (
      <Button basic icon disabled className="ExportDataButton__toolbar-button">
        <Icon className="file export ExportDataButton__limegreen-color" />
      </Button>
    );

  return (
    <Popup
      content={contentMessage}
      on="hover"
      position="bottom right"
      pinned
      style={{ opacity: hasWarning ? 1 : 0 }}
      trigger={
        <Button basic icon className="ExportDataButton__toolbar-button" onClick={hasWarning ? () => {} : handleOnClick}>
          <Icon className="file export ExportDataButton__limegreen-color" />
        </Button>
      }
    />
  );
};
